/* eslint no-template-curly-in-string: "off" */

import { CURRENCY_SELECTORS, FLOW_TYPES } from "../../../utils/enums";
import defaultCompleteImg from "../../../assets/images/default-complete-success.jpg";

const components = {
  loadingPage: {
    imgSrc: null,
  },
  paywall: {
    title: "Elija su Forma de Pago",
    tile: {
      btnLabel: 'Proceder',
    },
    disabledPaymentNetwork: {
      title: 'Red de Pagos No Disponible',
      description: '${paymentNetwork.displayName} no está disponible por el momento. Por favor, vuelva a intentar usar ${paymentNetwork.displayName} o seleccione una de las otras opciones de pago disponibles.',
    },
    byCurrencySelector: {
      CUSTOMER: {
        description: [
          "¿Cómo le gustaría recibir su pago de ",
          {
            string: "${payment.amount}",
            transformations: [
              {
                type: "formatAsCurrency",
                data: {
                  currency: "${payment.currency}"
                }
              }
            ],
            props: {
              className: "payment-amount",
            }
          },
          "?"
        ]
      },
      RECIPIENT: {
        description: [
          "¿Cómo le gustaría recibir el equivalente de su pago de ",
          {
            string: "${payment.amount}",
            transformations: [
              {
                type: "formatAsCurrency",
                data: {
                  currency: "${payment.currency}"
                }
              }
            ],
            props: {
              className: "payment-amount",
            }
          },
          "?"
        ],
      }
    }
  },
  recipientLogin: {
    redirectingToOauth: {
      title: "Redirigiendo a ${paymentNetwork.displayName}"
    },
    returningFromOauth: {
      title: "Recabando la Información del Usuario"
    }
  },
  acceptPayment: {
    title: "Confirmar Pago",
    btnLabel: "Aceptar Pago",
    description: [
      "Enviaremos ",
      {
        string: "${payment.amount}",
        transformations: [
          {
            type: "formatAsCurrency",
            data: {
              currency: "${payment.currency}"
            }
          }
        ],
        props: {
          className: "payment-amount",
        }
      },
      " a su cuenta de ",
      {
        string: "${paymentNetwork.displayName}",
        props: {
          className: 'payment-paymentNetwork',
        }
      },
      "."
    ],
    byCurrencySelector: {
      [CURRENCY_SELECTORS.RECIPIENT]: {
        description: [
          "Enviaremos ",
          {
            string: "${payment.amount}",
            props: {
              className: "payment-amount",
            },
            transformations: [
              {
                type: "formatAsCurrency",
                data: {
                  currency: "${payment.currency}"
                }
              }
            ]
          },
          " a su cuenta de ",
          {
            string: "${paymentNetwork.displayName}",
            props: {
              className: 'payment-paymentNetwork',
            }
          },
          "."
        ],
      }
    }
  },
  paymentComplete: {
    imgSrc: defaultCompleteImg,
    title: ["Pago Completo"],
    initial: {
      description: [
        "¡Éxito! Enviamos ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        " a su cuenta de ",
        {
          string: "${paymentNetwork.displayName}",
          props: {
            className: 'payment-paymentNetwork',
          }
        },
        "."
      ],
      secondaryText: [
        "La confirmación fue enviada a su correo electrónico o teléfono celular el ",
        {
          string: "${payment.updatedAt}",
          transformations: [
            {
              type: "formatDate"
            }
          ],
          props: {
            className: 'payment-updatedAt'
          }
        },
        "."
      ]
    },
    revisit: {
      description: [
        "El ",
        {
          string: "${payment.updatedAt}",
          transformations: [
            {
              type: "formatDate"
            }
          ],
          props: {
            className: 'payment-updatedAt'
          }
        },
        ", enviamos ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        " a su cuenta de ",
        {
          string: "${paymentNetwork.displayName}",
          props: {
            className: 'payment-paymentNetwork',
          }
        },
        "."
      ],
      secondaryText: [
        "La confirmación fue enviada a su correo electrónico o teléfono celular el ",
        {
          string: "${payment.updatedAt}",
          transformations: [
            {
              type: "formatDate"
            }
          ],
          props: {
            className: 'payment-updatedAt'
          }
        },
        "."
      ]
    },
  },
  validatePayment: {
    flow: FLOW_TYPES.VALIDATE_PAYMENT.URL_VALIDATION,
    initialVisit: {
      title: 'Cargando el Pago'
    },
    returningFromOauth: {
      title: "Recabando la Información del Usuario"
    }
  },
  pendingTransaction: {
    title: ["Pago Pendiente"],
    secondaryText: [
      "Algunos pagos tardan un poco más de tiempo en procesarse. Por favor, revise su correo electrónico en busca de la confirmación del depósito del pago, así como enlaces a tarjetas digitales activas de débito y de regalo."
    ]
  },
  pollingForComplete: {
    title: "Transfiriendo los Fondos",
    description:
      "Por favor, sea paciente. Las transacciones pueden tardar hasta 30 segundos en completarse."
  },
};

export default components;
